<template>
  <div class="HardwareEquipment">
    <div class="page_img">
      <img src="@/assets/img/hardware_device.jpg" alt="" />
    </div>
    <div class="content1 flex_row page_content">
      <div class="content_title summary_top">
        <img
          class="back_left back_left1"
          src="@/assets/img/scienceBorder_left.png"
          alt=""
        />
        <img
          class="back_right back_right1"
          src="@/assets/img/scienceBorder_right.png"
          alt=""
        />
        <div class="page_summary font_shadow">VISUMALL硬件设备</div>
      </div>
    </div>
    <div class="flex_row content2" @click="showVersion">
      <div class="flex_row content2_inside">
        <img src="@/assets/img/version_sigh.png" alt="" />
        <span style="margin-left: 0.1rem">功能明细对照表</span>
      </div>
    </div>
    <div class="content">
      <div class="content_item" v-for="(item, index) in list">
        <div class="item_left flex_column_end">
          <div class="left_back">
            <img class="bg-gray-100" :src="item.src" alt="" />
            <p
              class="mt-10 font-bold text-center text-blue-500 cursor-pointer"
              @click="handleShowProductDetail(index)"
            >
              查看详情
            </p>
          </div>
        </div>
        <div class="item_right">
          <div class="title font_shadow">{{ item.title }}</div>
          <div class="price font_shadow">
            <!--            <span v-if="item.price > 0">￥{{item.price}}元</span>-->
            <!--            <span v-else>已停产</span>-->
          </div>
          <div class="info">{{ item.info }}</div>
          <div class="tag" v-for="tag in item.tag1">
            <span v-show="tag.optionVis"></span>{{ tag.option }}
          </div>
          <div class="tag" v-for="tag in item.tag"><span></span>{{ tag }}</div>
          <div class="size1"></div>
          <div class="size" style="text-align: left" v-for="size in item.size">
            {{ size.content }}
            <div class="visible" v-if="size.visible">(高度*宽度*厚度）</div>
          </div>
        </div>
      </div>
      <div class="content_item">
        <div class="item_left flex_column_end">
          <div class="left_back" style="width: 70%">
            <img :src="independent.src" alt="" />

            <!--            <div><button style="-->
            <!--            background: #6ad1ff;-->
            <!--            color: #fff;-->
            <!--            padding: 0.1rem 0.2rem;-->
            <!--            border-radius: 0.1rem;-->
            <!--            font-size: 0.13rem;-->
            <!--            border: 1px solid #6ad1ff;-->
            <!--            font-weight: 500;-->
            <!--" class="regBtn" @click="regBtn(5)" v-if="independent.price > 0">查看价格</button></div>-->
            <p class="mt-10 font-bold text-center text-blue-500 cursor-pointer" @click="openDevice6Detail">
              查看详情
            </p>
          </div>
        </div>
        <div class="item_right">
          <div class="title font_shadow">{{ independent.title }}</div>
          <div class="price font_shadow">
            <!--            <span v-if="independent.price > 0">￥{{independent.price}}元</span>-->
            <!--            <span v-else>已停产</span>-->
          </div>
          <div class="info">{{ independent.info }}</div>
          <div class="tag" v-for="tag in independent.tag1">
            <span v-show="tag.optionVis"></span>{{ tag.option }}
          </div>
          <div class="tag" v-for="tag in independent.tag">
            <span></span>{{ tag }}
          </div>
          <div class="size1"></div>
          <div
            class="size"
            style="text-align: left"
            v-for="size in independent.size"
          >
            {{ size.content }}
            <div class="visible" v-if="size.visible">(高度*宽度*厚度）</div>
          </div>
        </div>
      </div>
    </div>

    <div class="equipment" v-for="item in list1">
      <div
        class="equipment_item"
        v-for="item1 in item"
        @click="jumpClick(item1.key)"
      >
        <div class="mask_back">
          <img :src="item1.src" alt="" />
          <div class="mask flex_row">详情介绍</div>
        </div>
        <div class="info font_shadow">{{ item1.title }}</div>
      </div>
    </div>

    <div class="page_system flex_column printFrame">
      <div class="sys_title flex_column">
        <div class="sys_summary print_summary">3D打印镜框</div>
        <div class="line_circle">
          <div class="line"></div>
          <div class="circle"></div>
        </div>
      </div>
      <div class="print_item">
        <div class="flex_column">
          <div
            style="
              margin-top: 0.55rem;
              background: #5575ff;
              color: #fff;
              font-weight: bold;
              padding: 0.1rem 0.2rem;
              font-size: 0.26rem;
            "
          >
            了解3D打印镜框
          </div>
          <div class="flex_row" style="margin: 0.3rem 0 1rem; cursor: pointer">
            <div
              class="flex_row"
              @click="commandClick('a')"
              style="
                margin-right: 0.3rem;
                border-radius: 0.1rem;
                border: 1px solid #666;
              "
            >
              <span style="font-size: 0.2rem; padding: 0 0.1rem"
                >3D打印设备</span
              >
              <img
                style="
                  width: 0.45rem;
                  padding: 0 0.1rem;
                  border-left: 1px solid #666;
                "
                src="@/assets/img/video.png"
              />
            </div>
            <div
              class="flex_row"
              @click="commandClick('b')"
              style="
                margin-left: 0.3rem;
                border-radius: 0.1rem;
                border: 1px solid #666;
              "
            >
              <span style="font-size: 0.2rem; padding: 0 0.1rem"
                >3D打印工艺</span
              >
              <img
                style="
                  width: 0.45rem;
                  padding: 0 0.1rem;
                  border-left: 1px solid #666;
                "
                src="@/assets/img/video.png"
              />
            </div>
          </div>
        </div>
        <div class="print_content flex_row">
          <div class="print_left print flex_column">
            <!--            @/assets/img/software_content1.png-->
            <img
              src="https://www.visumall.com/public/img/software_content1.jpg"
              alt=""
            />
          </div>
          <div class="print_right print flex_column">
            <img src="@/assets/img/software_content.png" alt="" />
          </div>
        </div>
        <div class="div flex_row">
          <div class="print_left print flex_column">
            <div class="print_btn">
              <button>头部3D建模</button>
            </div>
          </div>
          <div class="print_right print flex_column">
            <div class="print_btn">
              <button>体验式个性化</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="page_system flex_column printFrame">
      <div class="sys_title flex_column">
        <div class="sys_summary print_summary">设备配置对照表</div>
        <div class="line_circle">
          <div class="line"></div>
          <div class="circle"></div>
        </div>
      </div>
      <div class="deploy_items">
        <div class="deploy_item flex_row">
          <div class="border_left_top flex_row">项次</div>
          <div class="border_left_top flex_row border_flex2">设备列表</div>
          <div class="border_left_top flex_row border_flex2">用途</div>
          <div class="border_left_top flex_row">眼镜店</div>
          <div class="border_left_top flex_row">视光中心</div>
          <div class="border_left_top flex_row">眼科诊所</div>
          <div class="border_left_top flex_row">眼科门诊</div>
          <div class="border_left_top border_right flex_row">眼科医院</div>
        </div>
        <div class="deploy_item flex_row" v-for="(item, index) in disposeList">
          <div class="border_left_top flex_row">{{ index + 1 }}</div>
          <div class="border_left_top flex_row border_flex2">
            {{ item.device }}
          </div>
          <div class="border_left_top flex_row border_flex2">
            {{ item.purpose }}
          </div>
          <div class="border_left_top flex_row">
            <img
              v-show="item.opticalShop ? true : false"
              src="@/assets/img/version_star.png"
              alt=""
            />
          </div>
          <div class="border_left_top flex_row">
            <img
              v-show="item.visualCenter ? true : false"
              src="@/assets/img/version_star.png"
              alt=""
            />
          </div>
          <div class="border_left_top flex_row">
            <img
              v-show="item.eyeInfirmary ? true : false"
              src="@/assets/img/version_star.png"
              alt=""
            />
          </div>
          <div class="border_left_top flex_row">
            <img
              v-show="item.eyeClinic ? true : false"
              src="@/assets/img/version_star.png"
              alt=""
            />
          </div>
          <div class="border_left_top flex_row border_right">
            <img
              v-show="item.eyeHospital ? true : false"
              src="@/assets/img/version_star.png"
              alt=""
            />
          </div>
        </div>
        <div class="deploy_item" style="margin-bottom: 1.5rem">
          <div class="border_bottom"></div>
        </div>
      </div>
    </div>

    <bottom></bottom>
    <el-dialog
      title=""
      class="sp"
      :visible.sync="videoDialogVisible"
      width="80%"
      :destroy-on-close="true"
    >
      <video
        v-if="videoDialogVisible"
        style="width: 100%"
        controls
        autoplay="autoplay"
      >
        <source :src="videoSrc" type="video/mp4" />
        <source :src="videoSrc" type="video/ogg" />
        您的浏览器不支持Video标签。
      </video>
    </el-dialog>
    <el-dialog
      title="智慧视典验配设备功能明细"
      width="80%"
      class="DialogVisible"
      :visible.sync="dialogVisible"
    >
      <div class="VersionDifferent">
        <div class="version_tips">
          以下功能分别分布在：智能设备端，患者手机端，诊疗流程PAD/PC端，医生手机端，管理PC端
        </div>
        <div class="version_body">
          <div
            class="version_items flex_row"
            v-for="(item1, index1) in versionData"
          >
            <div
              class="version_item version_item2 flex_row"
              :class="index1 >= versionData.length - 1 ? 'body_bottom' : ''"
            >
              <span :class="index1 < 3 ? 'version_item3' : ''">{{
                item1.info
              }}</span>
            </div>

            <div
              v-if="item1.flag"
              class="version_item flex_row"
              :class="[
                index1 >= versionData.length - 1 ? 'body_bottom' : '',
                index2 >= item1.tags.length - 1 ? 'body_right' : '',
                '',
              ]"
              v-for="(item2, index2) in item1.tags"
            >
              <span
                :class="
                  index1 == 0
                    ? 'version_item4'
                    : index1 == 1
                    ? 'version_item5'
                    : ''
                "
                >{{ item2 }}</span
              >
            </div>

            <div
              v-if="!item1.flag"
              class="version_item flex_row"
              :class="[
                index1 >= versionData.length - 1 ? 'body_bottom' : '',
                index2 >= item1.tags.length - 1 ? 'body_right' : '',
              ]"
              v-for="(item2, index2) in item1.tags"
            >
              <img
                v-show="item2 == 2 ? true : false"
                src="@/assets/img/version_tag.png"
                alt=""
              />
              <img
                v-show="item2 == 3 ? true : false"
                src="@/assets/img/version_star.png"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- 产品详细 -->
    <el-dialog
      :visible.sync="showProductDetail"
      width="80%"
      :destroy-on-close="true"
    >
      <img
        class="w-full"
        :src="previewDetailImg"
        :alt="list[currentProductIndex].title"
      />
      <span
        class="absolute right-0 text-red-500 cursor-pointer el-icon-error"
        style="font-size: 46px; top: 90px"
        @click="showProductDetail = false"
      ></span>
    </el-dialog>
  </div>
</template>

<script>
import bottom from "@/components/pc/bottom";
import shebei3 from "@/assets/img/3.0.jpg";
import shebei6 from "@/assets/img/yuan2.0.jpg";
export default {
  name: "HardwareEquipment",
  components: {
    bottom,
  },
  data() {
    return {
      currentProductIndex: 0,
      showProductDetail: false,
      // 预览产品详细图片
      previewDetailImg: "",
      list: [],
      list1: [],
      idx: 0,
      independent: {},
      disposeList: [],
      videoDialogVisible: false,
      videoSrc: "",
      dialogVisible: false,
      versionData: [
        {
          info: "设备型号",
          flag: true,
          tags: ["2.0", "4.0", "5.0", "6.0"],
        },
        {
          info: "价格",
          flag: true,
          tags: ["¥38k", "¥128k", "¥128k", "¥200k"],
        },
        {
          info: "功能清单",
          flag: true,
          tags: ["", "", "", ""],
        },
        {
          info: "佩戴分析",
          tags: [2, 2, 2, 2],
        },
        {
          info: "定制验配测量",
          tags: [2, 2, 2, 2],
        },
        {
          info: "科普演示",
          tags: [2, 2, 2, 2],
        },
        {
          info: "眼部自测",
          tags: [2, 2, 2, 2],
        },
        {
          info: "AI处方",
          tags: [1, 2, 2, 2],
        },
        {
          info: "视力测量",
          tags: [1, 2, 2, 2],
        },
        {
          info: "3D建模试戴输出打印镜框",
          tags: [1, 2, 2, 2],
        },
        {
          info: "屈光筛查",
          tags: [1, 1, 2, 2],
        },
        {
          info: "校筛近视防控系统",
          tags: [1, 1, 2, 1],
        },
        {
          info: "眼底诊断",
          tags: [1, 2, 1, 2],
        },
        {
          info: "场景模拟",
          tags: [1, 1, 1, 2],
        },
        {
          info: "专家在线",
          tags: [1, 2, 1, 2],
        },
        {
          info: "远程诊疗",
          tags: [1, 1, 1, 2],
        },
      ],
    };
  },
  created() {
    const src = "software_content1";
    let list = [
      // {
      //   src: 'https://www.visumall.com/public/img/equipment1.jpg',
      //   title: '智慧视典 1.0',
      //   info: '专业功能介绍：',
      //   price: 0,
      //   tip: [],
      //   tag1: [{
      //     option: '配镜参数测量',
      //     optionVis: true
      //   },
      //     {
      //       option: '（瞳距/瞳高/镜眼距/前倾角）',
      //       optionVis: false
      //     }],
      //   tag: ['眼镜配戴评估','智能验配渐进眼镜','眼底评估','视力自测','智能处方','场景体验','专家远程'],
      //   size: [
      //     {
      //       content:'可适用身高范围：80cm--220cm',
      //       visible: false
      //     },{
      //       content:'设备尺寸：190cm*80cm*25cm',
      //       visible: true,
      //     }],
      // },
      {
        src: "https://www.visumall.com/public/img/equipment7.jpg",
        detailImg:
          "https://zsjstaticfile.oss-cn-shenzhen.aliyuncs.com/ForumArtical/2611585c-be32-46df-9a39-e08d02105091/2611585c-be32-46df-9a39-e08d02105091_1706256676078.jpg",
        title: "智慧视典2.0",
        price: 39000,
        info: "专业功能介绍：",
        tip: [],
        tag1: [
          {
            option: "配镜参数测量",
            optionVis: true,
          },
          {
            option: "（瞳距/瞳高/镜眼距/前倾角）",
            optionVis: false,
          },
        ],
        tag: [
          "眼镜配戴评估",
          "智能验配渐进眼镜",
          "智能对数视力表",
          "眼镜配戴评估",
          "眼底评估",
          "场景体验",
          "自动识别追踪眼球",
          "自动识别高低升降",
        ],
        size: [
          {
            content: "升降区间：100cm--210cm",
            visible: false,
          },
          {
            content: "可适用身高范围：80cm--220cm",
            visible: false,
          },
          {
            content: "设备尺寸：190cm*80cm*60cm",
            visible: true,
          },
        ],
      },
      {
        src: shebei3,
        title: "智慧视典 3.0",
        detailImg:
          "https://zsjstaticfile.oss-cn-shenzhen.aliyuncs.com/ForumArtical/34d3c4f4-a5a3-472c-aba5-3e1a0fc177cc/34d3c4f4-a5a3-472c-aba5-3e1a0fc177cc_1706256734937.jpg",
        price: 68000,
        info: "专业功能介绍：",
        tip: [],
        tag: [
          "直观展示智能配镜体验",
          "360°全自动自动结构光扫描",
          "3D打印镜框",
          "AR全场景实时适配",
          "专家远程诊疗",
          "AI 智能处方",
          "患者电子病历管理",
          "智能眼底评估",
          "眼镜佩戴3D评估",
          "视力筛查测量评估",
          "视疲劳测量评估",
        ],
        size: [
          {
            content: "升降区间：120cm--200cm",
            visible: false,
          },
          {
            content: "可适用身高范围：80cm--220cm",
            visible: false,
          },
          {
            content: "设备尺寸：190cm*80cm*60cm",
            visible: true,
            tip: "(高度*宽度*厚度）",
          },
        ],
      },
      {
        src: "https://www.visumall.com/public/img/software_content1.jpg",
        title: "智慧视典 4.0",
        detailImg:
          "https://zsjstaticfile.oss-cn-shenzhen.aliyuncs.com/ForumArtical/ecbd5f1e-85c1-4211-91ae-0bdf6fc491ba/ecbd5f1e-85c1-4211-91ae-0bdf6fc491ba_1706257014031.jpg",
        price: 150000,
        info: "专业功能介绍：",
        tip: ["（扫描臂可自动升降自动旋转）"],
        tag: [
          "360°全自动结构光扫描",
          "智能配镜3D建模",
          "3D打印镜框",
          "3D医美",
          "AR全场景实时适配",
          "专家远程诊疗",
          "AI 智能处方",
          "患者电子病历管理",
          "智能眼底评估",
          "眼镜佩戴3D评估",
          "视力筛查测量评估",
          "视疲劳测量评估",
        ],
        size: [
          {
            content: "升降区间：120cm--240cm",
            visible: false,
          },
          {
            content: "可适用身高范围：80cm--220cm",
            visible: false,
          },
          {
            content: "设备尺寸：195cm*110cm*90cm",
            visible: true,
          },
        ],
      },
      {
        // src: "https://www.visumall.com/public/img/equipment3.jpg",
        src: "https://zsjstaticfile.oss-cn-shenzhen.aliyuncs.com/ForumArtical/97f71c9d-29a1-474d-9759-6ff502332c9d/97f71c9d-29a1-474d-9759-6ff502332c9d_1706255645876.jpg",
        title: "智慧视典 5.0",
        detailImg:
          "https://zsjstaticfile.oss-cn-shenzhen.aliyuncs.com/ForumArtical/282dfd75-c207-4a8a-8d29-6f169aea1c05/282dfd75-c207-4a8a-8d29-6f169aea1c05_1706257145953.jpg",
        price: 98000,
        info: "专业功能介绍：",
        tip: [],
        tag: [
          "智能对数视力表",
          "双眼同时屈光度测量",
          "散光轴向测量",
          "双眼瞳距测量",
          "自动识别追踪眼球",
          "自动识别高低升降",
          "眼镜配戴评估",
          "眼底评估",
          "场景体验",
          "近视防控筛查管理系统",
          "无人自助校园筛查",
        ],
        size: [
          {
            content: "升降区间：100cm--210cm",
            visible: false,
          },
          {
            content: "可适用身高范围：80cm--220cm",
            visible: false,
          },
          {
            content: "设备尺寸：190cm*80cm*60cm",
            visible: true,
          },
        ],
      },
    ];
    let list1 = [];
    list1[0] = [
      {
        src: "https://www.visumall.com/public/img/hard_equipment1.jpg",
        title: "屏幕视力表",
        key: 1,
      },
      {
        src: "https://www.visumall.com/public/img/hard_equipment2.jpg",
        title: "智能视力筛查仪",
        key: 2,
      },
      {
        src: "https://www.visumall.com/public/img/hard_equipment3.jpg",
        title: "远程综合验光仪",
        key: 3,
      },
      {
        src: "https://www.visumall.com/public/img/hard_equipment4.jpg",
        title: "智能焦度计",
        key: 4,
      },
    ];
    list1[1] = [
      {
        src: "https://www.visumall.com/public/img/hard_equipment5.jpg",
        title: "远程智能验光仪",
        key: 5,
      },
      {
        src: "https://www.visumall.com/public/img/hard_equipment6.jpg",
        title: "眼底诊断",
        key: 0,
      },
      {
        src: "https://www.visumall.com/public/img/hard_equipment7.jpg",
        title: "数码裂隙灯",
        key: 6,
      },
      {
        src: "https://www.visumall.com/public/img/hard_equipment8.jpg",
        title: "角膜地形图仪",
        key: 0,
      },
    ];
    this.list = list;
    this.list1 = list1;
    // 'https://www.visumall.com/public/img/remote_optometry.jpg'
    this.independent = {
      src: shebei6,
      title: "智慧视典 6.0",
      detailImg:
        "https://zsjstaticfile.oss-cn-shenzhen.aliyuncs.com/ForumArtical/e2a226d6-5d84-4613-a0ee-299e254bd6af/e2a226d6-5d84-4613-a0ee-299e254bd6af_1706257202047.jpg",
      price: 200000,
      info: "机器人综合验光",
      tag: [
        "远程专家验光",
        "AI机器人验光",
        "本地操控验光",
        "远程实时AR场景诊疗",
        "智慧视光门诊诊疗系统",
        "AI辅助智能诊断",
        "AI辅助智能外方",
        "人机智能语音交互完整验配",
      ],
    };

    this.disposeList = [
      {
        device: "对数视力表",
        purpose: "检查视力",
        opticalShop: "*",
        visualCenter: "*",
        eyeInfirmary: "*",
        eyeClinic: "*",
        eyeHospital: "*",
      },
      {
        device: "全自动电脑验光仪",
        purpose: "检查测量屈光度",
        opticalShop: "*",
        visualCenter: "*",
        eyeInfirmary: "*",
        eyeClinic: "*",
        eyeHospital: "*",
      },
      {
        device: "全自动主观验光仪",
        purpose: "主观验光",
        opticalShop: "*",
        visualCenter: "*",
        eyeInfirmary: "*",
        eyeClinic: "*",
        eyeHospital: "*",
      },
      {
        device: "远程诊疗一体机",
        purpose: "远程专家诊疗",
        opticalShop: "*",
        visualCenter: "*",
        eyeInfirmary: "*",
        eyeClinic: "*",
        eyeHospital: "*",
      },
      {
        device: "远程控制验光组合台",
        purpose: "验光调控组合台",
        opticalShop: "*",
        visualCenter: "*",
        eyeInfirmary: "*",
        eyeClinic: "*",
        eyeHospital: "*",
      },
      {
        device: "验光插片箱",
        purpose: "调试确定验光数据",
        opticalShop: "*",
        visualCenter: "*",
        eyeInfirmary: "*",
        eyeClinic: "*",
        eyeHospital: "*",
      },
      {
        device: "UV焦度计",
        purpose: "测量镜片度数",
        opticalShop: "*",
        visualCenter: "*",
        eyeInfirmary: "*",
        eyeClinic: "*",
        eyeHospital: "*",
      },
      {
        device: "智能配镜扫描仪",
        purpose: "配镜参数测量",
        opticalShop: "*",
        visualCenter: "*",
        eyeInfirmary: "*",
        eyeClinic: "*",
        eyeHospital: "*",
      },
      {
        device: "全自动视功能检测仪",
        purpose: "视功能检查分析",
        opticalShop: "",
        visualCenter: "*",
        eyeInfirmary: "*",
        eyeClinic: "*",
        eyeHospital: "*",
      },
      {
        device: "视功能训练类",
        purpose: "各类训练",
        opticalShop: "",
        visualCenter: "*",
        eyeInfirmary: "*",
        eyeClinic: "*",
        eyeHospital: "*",
      },
      {
        device: "检眼镜",
        purpose: "简易眼部基本检查",
        opticalShop: "",
        visualCenter: "",
        eyeInfirmary: "*",
        eyeClinic: "*",
        eyeHospital: "*",
      },
      {
        device: "数码裂隙灯",
        purpose: "眼部常规检查",
        opticalShop: "",
        visualCenter: "",
        eyeInfirmary: "*",
        eyeClinic: "*",
        eyeHospital: "*",
      },
      {
        device: "同视机",
        purpose: "视觉康复治疗训练",
        opticalShop: "",
        visualCenter: "",
        eyeInfirmary: "*",
        eyeClinic: "*",
        eyeHospital: "*",
      },
      {
        device: "斜弱视训练类",
        purpose: "治疗康复训练",
        opticalShop: "",
        visualCenter: "",
        eyeInfirmary: "*",
        eyeClinic: "*",
        eyeHospital: "*",
      },
      {
        device: "角膜曲率计",
        purpose: "测量角膜曲率",
        opticalShop: "",
        visualCenter: "",
        eyeInfirmary: "*",
        eyeClinic: "*",
        eyeHospital: "*",
      },
      {
        device: "眼生物测量仪",
        purpose: "测量眼轴及相关数据",
        opticalShop: "",
        visualCenter: "",
        eyeInfirmary: "*",
        eyeClinic: "*",
        eyeHospital: "*",
      },
      {
        device: "眼压计",
        purpose: "测量眼压数据",
        opticalShop: "",
        visualCenter: "",
        eyeInfirmary: "*",
        eyeClinic: "*",
        eyeHospital: "*",
      },
      {
        device: "眼底诊断",
        purpose: "拍眼底照片诊断眼底病",
        opticalShop: "",
        visualCenter: "",
        eyeInfirmary: "*",
        eyeClinic: "*",
        eyeHospital: "*",
      },
      {
        device: "干眼检查分析仪",
        purpose: "干眼症检查",
        opticalShop: "",
        visualCenter: "",
        eyeInfirmary: "*",
        eyeClinic: "*",
        eyeHospital: "*",
      },
      {
        device: "干眼治疗仪",
        purpose: "干眼症治疗",
        opticalShop: "",
        visualCenter: "",
        eyeInfirmary: "*",
        eyeClinic: "*",
        eyeHospital: "*",
      },
      {
        device: "角膜地形图",
        purpose: "角膜相关数据和形态",
        opticalShop: "",
        visualCenter: "",
        eyeInfirmary: "",
        eyeClinic: "*",
        eyeHospital: "*",
      },
      {
        device: "角膜内皮细胞计数仪",
        purpose: "内皮细胞数量计量",
        opticalShop: "",
        visualCenter: "",
        eyeInfirmary: "",
        eyeClinic: "*",
        eyeHospital: "*",
      },
      {
        device: "眼科电生理仪",
        purpose: "电生理",
        opticalShop: "",
        visualCenter: "",
        eyeInfirmary: "",
        eyeClinic: "*",
        eyeHospital: "*",
      },
      {
        device: "光学相干断层扫描仪OCT",
        purpose: "断层扫描",
        opticalShop: "",
        visualCenter: "",
        eyeInfirmary: "",
        eyeClinic: "*",
        eyeHospital: "*",
      },
      {
        device: "视野计",
        purpose: "视野范围检测",
        opticalShop: "",
        visualCenter: "",
        eyeInfirmary: "",
        eyeClinic: "*",
        eyeHospital: "*",
      },
      {
        device: "波前像差仪",
        purpose: "人眼角膜波前像差分析",
        opticalShop: "",
        visualCenter: "",
        eyeInfirmary: "",
        eyeClinic: "*",
        eyeHospital: "*",
      },
      {
        device: "视网膜荧光造影机",
        purpose: "造影",
        opticalShop: "",
        visualCenter: "",
        eyeInfirmary: "",
        eyeClinic: "",
        eyeHospital: "*",
      },
      {
        device: "光凝激光仪",
        purpose: "激光类",
        opticalShop: "",
        visualCenter: "",
        eyeInfirmary: "",
        eyeClinic: "",
        eyeHospital: "*",
      },
      {
        device: "氩离子激光",
        purpose: "激光类",
        opticalShop: "",
        visualCenter: "",
        eyeInfirmary: "",
        eyeClinic: "",
        eyeHospital: "*",
      },
      {
        device: "手术显微镜",
        purpose: "手术显微镜",
        opticalShop: "",
        visualCenter: "",
        eyeInfirmary: "",
        eyeClinic: "",
        eyeHospital: "*",
      },
      {
        device: "白内障超声乳化机",
        purpose: "超声乳化",
        opticalShop: "",
        visualCenter: "",
        eyeInfirmary: "",
        eyeClinic: "",
        eyeHospital: "*",
      },
      {
        device: "制氧机",
        purpose: "吸氧",
        opticalShop: "",
        visualCenter: "",
        eyeInfirmary: "",
        eyeClinic: "",
        eyeHospital: "*",
      },
      {
        device: "空压机",
        purpose: "负压房间",
        opticalShop: "",
        visualCenter: "",
        eyeInfirmary: "",
        eyeClinic: "",
        eyeHospital: "*",
      },
      {
        device: "消毒机",
        purpose: "消毒",
        opticalShop: "",
        visualCenter: "",
        eyeInfirmary: "",
        eyeClinic: "",
        eyeHospital: "*",
      },
      {
        device: "手术床",
        purpose: "手术",
        opticalShop: "",
        visualCenter: "",
        eyeInfirmary: "",
        eyeClinic: "",
        eyeHospital: "*",
      },
      {
        device: "麻醉机",
        purpose: "麻醉",
        opticalShop: "",
        visualCenter: "",
        eyeInfirmary: "",
        eyeClinic: "",
        eyeHospital: "*",
      },
      {
        device: "无影灯",
        purpose: "手术",
        opticalShop: "",
        visualCenter: "",
        eyeInfirmary: "",
        eyeClinic: "",
        eyeHospital: "*",
      },
      {
        device: "血液检测",
        purpose: "手术",
        opticalShop: "",
        visualCenter: "",
        eyeInfirmary: "",
        eyeClinic: "",
        eyeHospital: "*",
      },
      {
        device: "血压测量",
        purpose: "手术",
        opticalShop: "",
        visualCenter: "",
        eyeInfirmary: "",
        eyeClinic: "",
        eyeHospital: "*",
      },
      {
        device: "血糖检查",
        purpose: "手术",
        opticalShop: "",
        visualCenter: "",
        eyeInfirmary: "",
        eyeClinic: "",
        eyeHospital: "*",
      },
      {
        device: "温度计",
        purpose: "",
        opticalShop: "",
        visualCenter: "",
        eyeInfirmary: "",
        eyeClinic: "",
        eyeHospital: "*",
      },
      {
        device: "内科相关",
        purpose: "",
        opticalShop: "",
        visualCenter: "",
        eyeInfirmary: "",
        eyeClinic: "",
        eyeHospital: "*",
      },
    ];

    this.videoDialogVisible = false;
    this.dialogVisible = false;
  },
  methods: {
    // 处理显示产品详细
    handleShowProductDetail(index) {
      this.currentProductIndex = index;
      this.previewDetailImg = this.list[index].detailImg;
      this.showProductDetail = true;
    },
    // 打开设备 6.0 详细
    openDevice6Detail() {
      this.previewDetailImg = this.independent.detailImg;
      this.showProductDetail = true;
    },
    commandClick(res) {
      this.videoDialogVisible = true;
      if (res == "a") {
        this.videoSrc = "https://resource.visumall.com/vm/3D打印设备~1.mp4";
      } else {
        this.videoSrc = "https://resource.visumall.com/vm/3D打印工艺~1.mp4";
      }
    },
    regBtn(index) {
      this.$router.push({
        path: "/Payment",
        query: {
          payment: index,
        },
      });
    },
    jumpClick(key) {
      if (key > 0) {
        this.$router.push({
          path: "/Introduce",
          query: {
            key: key,
          },
        });
      }
    },
    showVersion() {
      this.dialogVisible = true;
      // this.$router.push({path: '/VersionDifferent'});
    },
  },
};
</script>

<style scoped lang="scss">
.HardwareEquipment {
  .content1 {
    margin: 0.4rem 0 1rem;
  }
  .content2 {
    color: #fff;
    .content2_inside {
      background-color: #00b1ff;
      padding: 10px;
      border-radius: 5px;
      cursor: pointer;
      img {
        width: 0.32rem;
      }
      font-size: 0.27rem;
    }
  }
  .content {
    .content_item {
      display: flex;
      margin-top: 0.625rem;
      .item_left {
        margin-right: 2.5rem;
        flex: 1;
        .left_back {
          width: 40%;
          img {
            width: 100%;
          }
        }
      }
      .item_right {
        flex: 1;
        //margin-top: 0.2rem;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        .title {
          background: #e4e4e4;
          padding: 3px 40px 3px 3px;
          font-size: 0.27rem;
        }
        .price {
          margin-top: 0.1rem;
          color: #ff0000;
          font-size: 0.23rem;
        }
        .info {
          margin-top: 0.1rem;
          font-size: 0.23rem;
        }
        .size1 {
          margin: 0.05rem 0;
        }
        .tag,
        .size {
          margin-top: 0.05rem;
          font-size: 0.21rem;
          span {
            margin: 0 0.05rem;
            display: inline-block;
            width: 0.1rem;
            height: 0.1rem;
            background: #999;
            border-radius: 50%;
          }
        }
      }
    }
  }

  .equipment {
    margin: 0.5rem 0 1.7rem;
    display: flex;
    justify-content: space-around;
    .equipment_item {
      width: 15%;
      cursor: pointer;
      .mask_back:hover .mask {
        top: 0;
      }
      .mask_back {
        position: relative;
        overflow: hidden;
        img {
          width: 100%;
        }
        .mask {
          left: 0;
          top: 100%;
          background: rgba(0, 0, 0, 0.6);
          position: absolute;
          width: 100%;
          height: 100%;
          color: #fff;
          transition: all 0.6s;
        }
      }
      .info {
        margin-top: 0.5rem;
        font-size: 0.23rem;
      }
      .info:hover {
        transform: scale(1.06);
      }
    }
  }

  .printFrame {
    .print_summary {
      font-size: 0.3rem;
      font-weight: bold;
      display: inline-block;
    }
    .print_item {
      margin-top: 0.35rem;
      .print {
        flex: 1;
        justify-content: space-between;
        img {
          width: 45%;
        }
        .print_btn {
          margin: 0.5rem 0 1.7rem;
          button {
            cursor: pointer;
            font-size: 0.19rem;
            background: #5575ff;
            border: none;
            font-weight: 600;
            padding: 0.12rem 0.55rem;
            color: #fff;
          }
        }
      }
    }
    .deploy_items {
      width: 98%;
      margin-top: 0.55rem;
      .deploy_item {
        .border_left_top {
          flex: 1;
          height: 0.45rem;
          border-left: 0.01rem solid #b6b6b6;
          border-top: 0.01rem solid #b6b6b6;
          img {
            width: 0.28rem;
          }
        }
        .border_flex2 {
          flex: 2;
        }
        .border_bottom {
          border-bottom: 0.01rem solid #b6b6b6;
        }
        .border_right {
          border-right: 0.01rem solid #b6b6b6;
        }
      }
    }
  }

  ::v-deep .el-dialog {
    display: flex;
    display: -ms-flex; /* 兼容IE */
    flex-direction: column;
    -ms-flex-direction: column; /* 兼容IE */
    margin: 0 !important;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    //max-height:calc(100% - 30px);
    //max-width:calc(100% - 30px);
  }

  ::v-deep .el-dialog__body {
    padding: 0 20px;
  }
  ::v-deep .el-dialog__headerbtn {
    top: 10px;
  }
  .DialogVisible ::v-deep .el-dialog__body {
    padding: 0;
  }
  .VersionDifferent {
    margin: 0 auto;
    width: 100%;
    .border_none {
      border: none;
    }
    .version_tips {
      width: 100%;
      background: #ffffff;
      font-size: 0.16rem;
      text-align: center;
      padding-bottom: 0.1rem;
      color: #ff0000;
      //box-shadow:  0px 0.1rem 0.01rem 0 rgba(11, 3, 6, 0.22)
      box-shadow: 0px 0.07rem 0.07rem 0 rgba(11, 3, 6, 0.18);
    }
    .version_body {
      margin-top: 0.25rem;
      padding: 0 20px 0.5rem;
      .version_items {
        .version_item {
          height: 0.36rem;
          flex: 1;
          font-size: 0.15rem;
          color: #696969;
          border-left: 0.01rem solid #b6b6b6;
          border-top: 0.01rem solid #b6b6b6;
          img {
            width: 0.28rem;
          }
        }
        .version_item2 {
          flex: 2;
        }
        .version_item3 {
          color: #00a8ff;
          font-size: 0.18rem;
          font-weight: bold;
        }
        .version_item4 {
          font-size: 0.18rem;
          font-weight: bold;
          color: #000000;
        }
        .version_item5 {
          font-size: 0.18rem;
          font-weight: bold;
          color: #ff7800;
        }

        .body_bottom {
          border-bottom: 0.01rem solid #b6b6b6;
        }
        .body_right {
          border-right: 0.01rem solid #b6b6b6;
        }
      }
    }
  }
}
</style>
